/**
 * PWA & Mobile Installation Logic
 * Handles Android Install Prompt, iOS Instructions, and In-App Browser Detection.
 */

(function initPWA() {
    const installBtn = document.getElementById('pwaInstallBtn');
    const iosModal = document.getElementById('iosInstallModal');
    const closeIosModal = document.getElementById('closeIosModal');
    const inAppPopup = document.getElementById('inAppPopup');

    let deferredPrompt = null;

    // ===============================================
    // 1. Service Worker Registration
    // ===============================================
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            // By masking the string from Parcel's static analyzer, we avoid the bundle conflict
            const swUrl = window.location.origin + '/sw.js';
            navigator.serviceWorker.register(swUrl)
                .then(reg => console.log('SW Registered!', reg))
                .catch(err => console.log('SW Registration Failed', err));
        });
    }

    // ===============================================
    // 2. Detection Utils
    // ===============================================
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const isInApp = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) || (ua.indexOf("Instagram") > -1);
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;

    // If not mobile or already installed, stop
    if (!isMobile || isStandalone) return;

    // ===============================================
    // 3. Show In-App Popup (on click only)
    // ===============================================
    function showInAppPopup() {
        if (inAppPopup) {
            inAppPopup.hidden = false;
            setTimeout(() => { inAppPopup.hidden = true; }, 5000);
        }
    }

    // ===============================================
    // 4. Capture Android Install Event
    // ===============================================
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;

        // Show install button when prompt is available
        if (installBtn) {
            installBtn.style.display = 'inline-flex';
        }
    });

    // ===============================================
    // 5. iOS: Show button directly (no beforeinstallprompt on iOS)
    // ===============================================
    if (isIOS && installBtn) {
        installBtn.style.display = 'inline-flex';
    }

    // ===============================================
    // 6. Single Click Handler (handles all platforms)
    // ===============================================
    if (installBtn) {
        installBtn.addEventListener('click', async () => {
            // If in-app browser, show popup warning
            if (isInApp) {
                showInAppPopup();
                return;
            }

            // Android: Use the deferred prompt
            if (deferredPrompt) {
                try {
                    deferredPrompt.prompt();
                    const { outcome } = await deferredPrompt.userChoice;
                    console.log(`User response: ${outcome}`);
                } catch (err) {
                    console.log('Install prompt error:', err);
                }
                deferredPrompt = null;
                return;
            }

            // iOS: Show instruction modal
            if (isIOS && iosModal) {
                iosModal.hidden = false;
                iosModal.style.display = 'flex';
            }
        });
    }

    // ===============================================
    // 7. Close iOS Modal
    // ===============================================
    if (closeIosModal && iosModal) {
        closeIosModal.addEventListener('click', () => {
            iosModal.hidden = true;
            iosModal.style.display = 'none';
        });
        window.addEventListener('click', (e) => {
            if (e.target === iosModal) {
                iosModal.hidden = true;
                iosModal.style.display = 'none';
            }
        });
    }

})();
